<template>
  <div
    class="d-flex align-items-center flex-wrap"
    style="gap: 1rem"
    v-if="stats && stats.nbClients > 0"
  >
    <div class="badge badge-info">
      SD <span class="ml-05">x{{ stats.nbDiscovery }}</span>
    </div>

    <div :class="`badge badge-${tcBadgeStatus}`">
      TC
      <span class="ml-05">{{ stats.tc?.toFixed(2) }}%</span>
    </div>

    <div class="badge badge-info">
      <i class="icon-people"></i>
      <span class="ml-05">x{{ stats.nbClients }}</span>
    </div>

    <div :class="`badge badge-${longevityBadgeStatus}`">
      LC
      <span class="ml-05">{{ stats.clientLongevity }} s</span>
    </div>

    <Rates
      :value="parseFloat(stats.externalRanking)"
      :nbClientsVoted="stats.nbClientsVoted"
      size="fa-1x"
    />

    <div v-if="comments" class="comments">
      <span
        class="com-pos"
        v-tooltip="{
          content: displayComs(comments, 'positive'),
          placement: 'top',
        }"
      >
        <i class="fa fa-thumbs-up" />
        {{
          comments.filter((com) => {
            return com.type === 1;
          }).length
        }}
      </span>

      <span
        class="com-neu"
        v-tooltip="{
          content: displayComs(comments, 'neutral'),
          placement: 'top',
        }"
      >
        <i class="fa fa-minus-circle" />
        {{
          comments.filter((com) => {
            return com.type === 0;
          }).length
        }}
      </span>

      <span
        class="com-neg"
        v-tooltip="{
          content: displayComs(comments, 'negative'),
          placement: 'top',
        }"
      >
        <i class="fa fa-thumbs-down" />
        {{
          comments.filter((com) => {
            return com.type === -1;
          }).length
        }}
      </span>
    </div>

    <PopoverRejectedReasons
      v-if="percentageAttributed > 0"
      :coach-stats="stats"
    >
      <template
        >{{ stats.totalAttributionsAttributed }} attribué/{{
          totalAttributions
        }}
        ({{ percentageAttributed.toFixed(2) }}%)</template
      >

      <template #fallback
        >{{ stats.totalAttributionsAttributed }} attribué/{{
          totalAttributions
        }}
        ({{ percentageAttributed.toFixed(2) }}%)</template
      >
    </PopoverRejectedReasons>
  </div>
</template>

<script>
import PopoverRejectedReasons from "@/components/coach-manager/attributions-treated/PopoverRejectedReasons.vue";
import Rates from "@/components/utils/Rates";

export default {
  components: {
    PopoverRejectedReasons,
    Rates,
  },

  props: {
    stats: {
      type: Object,
      default: null,
    },
    comments: {
      type: Array,
      default: null,
    },
  },

  computed: {
    tcBadgeStatus() {
      if (this.stats.tc >= 66) {
        return "success";
      } else if (this.stats.tc >= 33 && this.stats.tc < 66) {
        return "warning";
      } else {
        return "danger";
      }
    },

    tfBadgeStatus() {
      if (this.stats.tf >= 66) {
        return "success";
      } else if (this.stats.tf >= 33 && this.stats.tf < 66) {
        return "warning";
      } else {
        return "danger";
      }
    },

    longevityBadgeStatus() {
      switch (this.stats.clientLongevityRank) {
        case "top":
          return "success";

        case "middle":
          return "warning";

        case "bad":
          return "danger";

        default:
          return "";
      }
    },

    totalAttributions() {
      return (
        this.stats.totalAttributionsAttributed +
        this.stats.totalAttributionsRejected
      );
    },

    percentageAttributed() {
      if (this.totalAttributions === 0) return 0;

      return (
        (this.stats.totalAttributionsAttributed / this.totalAttributions) * 100
      );
    },
  },

  methods: {
    displayComs(comments, type = "positive") {
      const predicates = {
        positive: (com) => com.type === 1,
        negative: (com) => com.type === -1,
        neutral: (com) => com.type === 0,
      };
      const comsToDisplay = comments.filter(
        predicates[type] || predicates.positive,
      );

      const strings = comsToDisplay.map(
        ({ label, text, author }, index) =>
          `${index + 1}. ${label} - ${text} (${author})`,
      );

      return strings.join(" ----- ");
    },
  },
};
</script>

<style scoped>
.success {
  background-color: #28a745;
  color: white;
}

.warning {
  background-color: #ffc107;
  color: black;
}

.danger {
  background-color: #dc3545;
  color: white;
}

.sd-container {
  padding-right: 15px;
  display: flex;
  align-items: center;
}

.com-pos {
  color: #28a745;
}

.com-neu {
  color: #868e96;
  margin-left: 4px;
}

.com-neg {
  color: #dc3545;
  margin-left: 4px;
}

.comments {
  min-width: max-content;
  display: flex;
  align-items: center;
}
</style>
